module.exports = __webpack_public_path__ + "static/BusinessOwner-478484eaf9bdc5ddd0934d85d1efb91f.jpg";